import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemErro, limpaMensagem, saveState, deleteState } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { Pagination } from "../Pagination/Pagination";
import { getMessagemErro } from "../../utils/erro";
import { formataData } from "../../utils/formatadorData";
import api from "../../services/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolderClosed } from "@fortawesome/free-solid-svg-icons";

const mapDispatchToProps = { saveState, deleteState, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		filters: state.filterStore,
	}
}

const initialState = {
	resultadoPesquisa: [],
	nomePastaSegura: "",
	pesquisaExecutada: false,
	botoesHabilitados: true,
};

export const PastaSeguraDisponivelList =

// router
withRouter(
// redux
connect(
	(mapStateToProps),
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.state = initialState;

			this.handleInputChange = this.handleInputChange.bind(this);
			this.pesquisar = this.pesquisar.bind(this);
			this.executaPesquisaPaginada = this.executaPesquisaPaginada.bind(this);
			this.limparPesquisa = this.limparPesquisa.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />

					<div style={{margin: "10px"}}>
						<h1>Pastas Seguras</h1>
					</div>

					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			if (this.props.location.state?.resetSearch) {
				this.executaPesquisaPaginada(0);
			} else {
				this.executarPesquisaAnterior();
			}
		}

		renderForm() {
			const { resultadoPesquisa, pesquisaExecutada, nomePastaSegura } = this.state;
			const { content } = resultadoPesquisa;

			return(
				<div className="container-fluid">
					<div className="br-form">
						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="nomePastaSegura">Nome da Pasta:</label>
										<input type="text" name="nomePastaSegura"
											value={nomePastaSegura}
											onChange={this.handleInputChange}
											maxLength="8"/>
									</div>
								</div>
							</div>
						</div>
						<div className="actions-button">
							<div className="actions justify-content-start">
								<button type="button" className="button is-primary" onClick={() => this.pesquisar()} disabled={!this.state.botoesHabilitados}>Pesquisar</button>
								<button type="button" className="button is-secondary" onClick={() => this.limparPesquisa()} disabled={!this.state.botoesHabilitados}>Limpar</button>
								<button type="button" className="button is-secondary" onClick={() => this.props.history.push('/grandes-volumes')} disabled={!this.state.botoesHabilitados}>Voltar</button>
							</div>
						</div>

						{(content && content.length > 0) &&
							<div className="br-table">
								<div className="table">
									<table>
										<thead>
											<tr>
												<th scope="col">Pasta Segura</th>
												<th scope="col">Status</th>
												<th scope="col">Órgão Vinculado</th>
												<th scope="col">Descoberta em</th>
												<th scope="col">Última Sincronização</th>
												<th className="text-center" scope="col">Ações</th>
											</tr>
										</thead>
										<tbody>
											{content.map((entrada, index) =>
												<tr key={index}>
													<td>{entrada.nomePastaSegura}</td>
													<td>{entrada.ativa ? 'Ativa' : 'Inativa'}</td>
													<td>{entrada.nomeOrgao || '-'}</td>
													<td>{formataData(entrada.dataDescoberta)}</td>
													<td>{formataData(entrada.dataUltimaSincronizacao)}</td>
													<td className="text-center">
														<div className="actions">
															{entrada.idOrgao &&
																<Link to={{
																	pathname: `/pasta-segura-disponivel/manutencao/${entrada.idOrgao}`,
																	state: { resetSearch: true, backTo: this.props.location.pathname },
																}}>
																	<button type="button" disabled={!this.state.botoesHabilitados} title="Trocar pasta segura do órgão">
																		<span className="sr-only">Trocar pasta segura do órgão</span>
																		<FontAwesomeIcon icon={faFolderClosed} style={{color: "#1351b4"}} />
																	</button>
																</Link>
															}
														</div>
													</td>
												</tr>
											)}
										</tbody>
									</table>
									<Pagination totalPaginas={resultadoPesquisa.totalPages} paginaAtual={resultadoPesquisa.number} onChangePage={this.executaPesquisaPaginada}/>
								</div>
							</div>
						}

						{(pesquisaExecutada && (!content || content.length === 0)) &&
							<div>
								Nenhuma pasta segura encontrada com os critérios informados.
							</div>
						}
					</div>
				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.value;
			this.setState({[nome]: valor});
		}

		executarPesquisaAnterior() {
			const lastState = this.props.filters[this.props.location.pathname];

			this.setState({
				...initialState,
				...lastState,
				pesquisaExecutada: false,
				resultadoPesquisa: []
			}, () => {
				if (lastState) {
					const lastPage = lastState ? lastState?.resultadoPesquisa?.number : 0;
					this.executaPesquisaPaginada(lastPage);
				}
			});
		}

		pesquisar(e){
			this.props.limpaMensagem();
			this.executaPesquisaPaginada(0);
			if (this.props.location.state?.resetSearch) {
				this.props.history.replace(this.props.location.pathname, {
					...this.props.location.state,
					resetSearch: false,
				});
			}
		}

		executaPesquisaPaginada(pagina){
			const { nomePastaSegura } = this.state;
			const url = '/api/pasta-segura-disponivel/paginado';

			const criterioPesquisa = {
				nomePastaSegura: nomePastaSegura,
				pagina: pagina,
			}

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa
			}

			this.props.mostraAguardando();
			api(options)
				.then(response => {
					this.setState({
						resultadoPesquisa: response.data,
						pesquisaExecutada: true,
					}, () => {
						this.props.saveState(this.state, this.props.location.pathname);
					})
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar as pastas seguras.", erro);
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
				});
		}

		limparPesquisa(){
			this.setState(initialState, () => {
				this.props.deleteState(this.state, this.props.location.pathname);
			});
		}
	}

) // redux
); // router
